import React, { Component } from "react";
import { Drawer, Button, Icon } from "@material-ui/core";

import ResetPassword from "./ResetPassword";

class ResetPasswordDrawer extends Component {
  state = {
    toggle: false,
  };

  handleClose = () => {
    this.setState({ toggle: true });
    this.props.toggleLoginDrawer();
  };

  render() {
    return (
      <Drawer
        open={this.props.openPasswordDrawer}
        onClose={this.props.closeLoginDrawer}
        anchor="right"
      >
        <div style={{ width: 400, padding: '20px 22px', boxSizing: 'border-box', }}>
          <div onClick={this.props.closeLoginDrawer}>
            <Button
              size="small"
              style={{ float:'left' }}
              onClick={this.props.toggleLoginDrawer}
            >
              <Icon style={{fontSize: 32,}}>close</Icon>
            </Button>
          </div>
          <ResetPassword history={this.props.history} />
        </div>
      </Drawer>
    );
  }
}
export default ResetPasswordDrawer;
